function logCallEvent(call_id, event_txt, event_type) {
    if (call_id < 1) return;
    var url;
    if (typeof(event_type) !== 'undefined')
        url = '/CallEvents/add/' + call_id + '/' + event_type;
    else
        url = '/CallEvents/add/' + call_id;
        $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            data: {'callId': call_id, 'event_txt': event_txt}
        }).done(function(jsondata) {
            if (!jsondata.success) {
                alert(jsondata.msg);
            } else {
                $('.calllog_eventlist').append(jsondata.row);
            }
        }).fail(ajaxCallFailure);
}

export { logCallEvent };